import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { Button, SpinningLoader } from 'common-components'
import { premiumButtonStyles } from 'containers/SubSidebar/styled'

export const AiImageGenerateFooter = styled.div`
  position: sticky;
  bottom: 0;
  padding: 20px 16px 12px;
  width: 100%;

  border-top: 1px solid ${COLORS.borderColor};

  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
`

export const ButtonContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const SpinningLoaderWrapper = styled(SpinningLoader)<{
  $isVisible: boolean
}>`
  position: absolute;
  left: -24px;
  top: 1px;
  width: 16px;
  height: 16px;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
`

export const GenerateButton = styled(Button)<{ $isPremium: boolean }>`
  width: 100%;
  ${premiumButtonStyles}
`

export const CreditsBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

export const ThunderIcon = styled.img`
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
`
